import {
  AfterViewInit,
  Component,
  computed,
  ElementRef,
  signal,
  ViewChild,
  inject,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { takeUntil, tap, timer } from 'rxjs';
import { LoadingService } from 'src/app/services/loading.service';
import { selectConfigLoading } from 'src/app/store/states/config/config.selectors';
import { ProgressBarComponent } from '../../progress-bar/progress-bar.component';

@Component({
  selector: 'app-loading-progress-bar',
  templateUrl: './loading-progress-bar.component.html',
  styleUrls: ['./loading-progress-bar.component.scss'],
  imports: [ProgressBarComponent],
})
export class LoadingProgressBarComponent implements AfterViewInit {
  @ViewChild('title') titleElement!: ElementRef;
  private store = inject(Store);
  protected loadingState = this.store.selectSignal(selectConfigLoading);
  private content = computed(() => this.loadingState().loadingConfig.content);
  private contentIndex = signal(0);
  protected actualContent = computed(() => this.content()![this.contentIndex()]);
  protected percentage = inject(LoadingService).progressBarPercentage;
  private readonly oneMinuteInMilliseconds = 60 * 1000;

  constructor() {
    this.startProgressBarChangeInterval();
  }
  ngAfterViewInit(): void {
    this.startTitleChangeInterval();
  }

  private startProgressBarChangeInterval() {
    const stepChangeTime = Math.floor(this.oneMinuteInMilliseconds / 5);
    timer(0, 100)
      .pipe(
        takeUntil(timer(this.oneMinuteInMilliseconds)),
        tap((timeLeft) => {
          const remainingProgressBarUpdate = (timeLeft * 100) % stepChangeTime;
          if (remainingProgressBarUpdate === 0) {
            this.percentage.update((percentage) => percentage + 20);
          } else {
            this.percentage.update((percentage) => percentage + 0.05);
          }
        })
      )
      .subscribe();
  }
  private startTitleChangeInterval() {
    if (this.titleElement) {
      const titleChangeBasedAnimation = 5 * 1000;
      timer(0, titleChangeBasedAnimation)
        .pipe(
          takeUntil(timer(this.oneMinuteInMilliseconds)),
          tap(() => {
            this.contentIndex.set((this.contentIndex() + 1) % (this.content()?.length || 0));
          })
        )
        .subscribe();
    }
  }
}
